function fInitScrollSpy() {
  const scrollspyNavigationItems = document.querySelectorAll('.js-scrollspy-navigation a');
  const scrollspySections = document.querySelectorAll('.js-scrollspy-sections .ss-section');

  const checkScrollPosition = () => {
    const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
    for (let i = 0; i < scrollspySections.length; i += 1) {
      if ((scrollspySections[i].getBoundingClientRect().top - 20) + (window.scrollY || window.pageYOffset) <= scrollPosition) {
        for (let p = 0; p < scrollspyNavigationItems.length; p += 1) {
          const item = scrollspyNavigationItems[p];

          if (item.classList.contains('is-active')) {
            item.classList.remove('is-active');
          }

          if (item.getAttribute('href') === `#${scrollspySections[i].id}`) {
            item.classList.add('is-active');
          }
        }
      }
    }
  };

  const scrollToSection = (e) => {
    const scrollDestEl = document.getElementById(e.target.getAttribute('href').slice(1));

    scrollIt(scrollDestEl, 400, 'easeInQuad', 0);
    e.preventDefault();
  };

  for (let p = 0; p < scrollspyNavigationItems.length; p += 1) {
    scrollspyNavigationItems[p].addEventListener('click', (e) => {
      scrollToSection(e);
    });
  }

  window.onscroll = () => checkScrollPosition();
  checkScrollPosition();
}
